import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import SearchUI from '../../../widgets/input/SearchUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI'
import './ProjectRoleList.css'

const ProjectRoleListUI = ({context, messageList, filteredProjectList,
    // refresh, filter
    onRefreshClick, searchFilter, onSearchFilterChange,
    // join, leave
    onJoinClick, onLeaveClick
  }) =>
  <div className='c_prj_role'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />
    <LRTableBodyUI context={context} className='menu'>
      {
        filteredProjectList.map((project, i) =>
          <LRTableRowUI key={i}
            context={context}
            left={<RowLeftUI context={context} messageList={messageList} project={project} />}
            right={
              <RowRightUI context={context} messageList={messageList} project={project}
                onJoinClick={onJoinClick} onLeaveClick={onLeaveClick}
              />
            }
          />
        )
      }
    </LRTableBodyUI>
    {
      filteredProjectList.length === 0 &&
      <div className='g_m_top_100'>
        <MessageUI messageList={messageList} messageKey='c_no_projects' />
      </div>
    }
  </div>

const RowLeftUI = ({context, messageList, project}) =>
  <div>
    <label className='name'>{project.projectName}</label>
    {
      project.projectType === 'template' &&
      <span className='icon icon-cube tag'></span>
    }
    {
      project.visibility === 'all' &&
      <span className='icon icon-globe tag'></span>
    }
    <span className='g_muted role'>{project.roleName}</span>
  </div>

const RowRightUI = ({context, messageList, project, onJoinClick, onLeaveClick}) =>
  <div>
    {
      project.roleId &&
      <div className='g_flex_h'>
        <SpinnerUI show={project.submitted} reserveSpace={true} />
        <ButtonTinyUI messageList={messageList} labelKey='c_leave' rowId={project.projectId} onClick={onLeaveClick} />
      </div>
    }
    {
      !project.roleId &&
      <ButtonTinyUI messageList={messageList} labelKey='c_join' rowId={project.projectId} onClick={onJoinClick} />
    }
  </div>

const ActionLeftUI = ({context, messageList, onRefreshClick}) =>
  <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange}) =>
  <SearchUI value={searchFilter} onChange={onSearchFilterChange} />

export default ProjectRoleListUI
